import { ALL_DIRECTORIES, Directory } from '../types';

export const getDirectoryFromLink = (
    link: string | undefined
): Directory | null => {
    if (!link) return null;
    return ALL_DIRECTORIES.find(d => link.startsWith(`/${d}s`)) ?? null;
};
